import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
import { AdminAuthProvider } from '@/context/AdminAuthContext'
import { CMSProvider } from '@/context/CMSContext'
import MainLayout from '@/layouts/MainLayout'
import AdminLayout from '@/layouts/AdminLayout'
import Home from '@/pages/Home'
import About from '@/pages/About'
import Services from '@/pages/Services'
import Projects from '@/pages/Projects'
import ProjectDetail from '@/pages/ProjectDetail'
import Contact from '@/pages/Contact'
import AdminLogin from '@/pages/admin/Login'
import AdminDashboard from '@/pages/admin/Dashboard'
import AdminProjects from '@/pages/admin/Projects'
import ProjectForm from '@/pages/admin/ProjectForm'
import AdminMessages from '@/pages/admin/Messages'
import AdminReviews from '@/pages/admin/Reviews'
import AdminEmail from '@/pages/admin/Email'
import AdminUsers from '@/pages/admin/Users'
import AdminSecurity from '@/pages/admin/Security'
import ScrollToTop from '@/components/ScrollToTop'
import { adminUrl, isAdminSubdomain } from '@/lib/siteUrls'

function App() {
  const adminSubdomain = isAdminSubdomain()

  return (
    <CMSProvider>
      <AdminAuthProvider>
        <Router>
          <ScrollToTop />
          <Routes>
            {/* Main Site Routes */}
            {!adminSubdomain && <Route element={<MainLayout />}>
              <Route path="/" element={<Home />} />
              <Route path="/about" element={<About />} />
              <Route path="/services" element={<Services />} />
              <Route path="/projects" element={<Projects />} />
              <Route path="/projects/:id" element={<ProjectDetail />} />
              <Route path="/contact" element={<Contact />} />
            </Route>}

            {/* Admin Routes */}
            <Route path={adminUrl('/login')} element={<AdminLogin />} />
            <Route element={<AdminLayout />}>
              <Route path={adminUrl()} element={<AdminDashboard />} />
              <Route path={adminUrl('/projects')} element={<AdminProjects />} />
              <Route path={adminUrl('/projects/new')} element={<ProjectForm />} />
              <Route path={adminUrl('/projects/edit/:id')} element={<ProjectForm />} />
              <Route path={adminUrl('/messages')} element={<AdminMessages />} />
              <Route path={adminUrl('/reviews')} element={<AdminReviews />} />
              <Route path={adminUrl('/email')} element={<AdminEmail />} />
              <Route path={adminUrl('/users')} element={<AdminUsers />} />
              <Route path={adminUrl('/security')} element={<AdminSecurity />} />
            </Route>
          </Routes>
        </Router>
      </AdminAuthProvider>
    </CMSProvider>
  )
}

export default App
